import { render, staticRenderFns } from "./NavbarComponent.vue?vue&type=template&id=bc8f800c&scoped=true&"
import script from "./NavbarComponent.vue?vue&type=script&lang=js&"
export * from "./NavbarComponent.vue?vue&type=script&lang=js&"
import style0 from "./NavbarComponent.vue?vue&type=style&index=0&id=bc8f800c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8f800c",
  null
  
)

export default component.exports